export enum ExceptionCategoryEnum {
  RELIGIOUS_ACCOMMODATIONS = 'Religious Accommodations',
  MEDICAL_ACCOMMODATIONS = 'Medical Accommodations',
  CONTRACTUAL_ACCOMMODATIONS = 'Contractual Accommodations',
  NURSING_ACCOMMODATIONS = 'Nursing Accommodations',
  LUNCH_ACCOMMODATION = 'Lunch Accommodation',
  HOO_PATCH = 'HOO Patch',
  OTHER = 'Other',
}
